import axios from 'axios'

export async function fetchSetting(): Promise<{
  stake_lc_ratio_json: {
    flexible: number
    locked30: number
    locked90: number
    locked180: number
    [key: string]: number
  }
}> {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/settings`,
  )
  return {
    stake_lc_ratio_json: response.data.stake_lc_ratio_json,
  }
}
